module.exports = __webpack_public_path__ + "img/scanCodeSuccessfully.8f266d97.svg";